import { render, staticRenderFns } from "./OrderStepsTable.vue?vue&type=template&id=88d1ff64&scoped=true&"
import script from "./OrderStepsTable.vue?vue&type=script&lang=js&"
export * from "./OrderStepsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderStepsTable.vue?vue&type=style&index=0&id=88d1ff64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1ff64",
  null
  
)

export default component.exports